module.exports = __webpack_public_path__ + "static/media/Silder10.b2ee9175.webp";